import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useUser } from '../../useUser';
import { AccountDesignerPreferencesVertical } from '../../useDesigners';
import { GET_DESIGNER_PREFERENCES_QUERY } from '../useDesignerPreferences.rest';
import { FOLLOW_DESIGNER_MUTATION } from './useFollowDesigner.rest';

export const useFollowDesigner = (vertical: AccountDesignerPreferencesVertical) => {
  const { user } = useUser();

  const [mutate, { loading, error }] = useMutation(FOLLOW_DESIGNER_MUTATION);

  const followDesigner = useCallback(
    (designerId: number) =>
      mutate({
        variables: {
          input: {
            designer_id: designerId,
            user_id: Number(user.id),
            inference_type: 'explicit',
            action: 'follow',
            vertical
          }
        },
        refetchQueries: [
          {
            query: GET_DESIGNER_PREFERENCES_QUERY,
            variables: {
              userId: user.id,
              vertical
            }
          }
        ]
      }),
    [mutate, user.id, vertical]
  );

  return {
    followDesigner,
    loading,
    error
  };
};
